'use client'

import { memo } from 'react'
import { CraftShell } from '../_components/craft-shell'
import { NinxlBanksHeroBackground } from '../_components/ninxl-banks-hero-background'
import { NinxlBanksSection } from '../_components/ninxl-banks-section'

/** baby: Banks keeps section content; craft shell replaces 8bit chrome. */
const NinxlBanksPage = () => (
  <CraftShell>
    <NinxlBanksHeroBackground />
    <main>
      <NinxlBanksSection />
    </main>
  </CraftShell>
)

export default memo(NinxlBanksPage)
